import { render, staticRenderFns } from "./glTab.vue?vue&type=template&id=56c926ea&scoped=true"
import script from "./glTab.vue?vue&type=script&lang=js"
export * from "./glTab.vue?vue&type=script&lang=js"
import style0 from "./glTab.vue?vue&type=style&index=0&id=56c926ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c926ea",
  null
  
)

export default component.exports